
import DateComponent from '@/components/DateComponent.vue';
import LogShowComponent from '@/components/LogShowComponent.vue';
import { IAvaliacaoCreate } from '@/interfaces/avaliacao';
import { IUserProfileCreate, IUserProfileUpdate } from '@/interfaces/user_profile';
import { IUserTool } from '@/interfaces/user_tool';
import {
  actionStore,
  adminStore,
  avaliacaoStore,
  companyStore,
  departureStore,
  mainStore,
  roleStore,
  toolStore,
  userActionStore,
  userToolStore,
} from '@/store';
import { addDays, format, parseISO } from 'date-fns';
import _ from 'lodash';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { confirmed, required, min, email } from 'vee-validate/dist/rules';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

extend('email', { ...email, message: 'Digite um {_field_} válido!' });
extend('min', {
  ...min,
  message: 'O campo {_field_} precisa ter pelo menos {length} caracteres!',
});
extend('required', {
  ...required,
  message: 'Campo {_field_} deve ser preenchido!',
});
extend('confirmed', { ...confirmed, message: 'As senhas devem ser iguais!' });
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    LogShowComponent,
    DateComponent,
  },
})
export default class Create extends Vue {
  @Prop({ type: Number, default: 0 }) readonly propUserId;

  // public $refs!: {
  //   observer: InstanceType<typeof ValidationObserver>;
  // };

  searchTool = '';
  searchAction = '';

  public camelCaseSplitRegex = /([a-z0-9])([A-Z])/g;

  public loadingDataTable = false;

  public id: number | null = null;

  public fullName = '';

  public email = '';

  public password1 = '';

  public password2 = '';

  public telefone = '';

  public celular = '';

  public isActive = true;

  public selectedDeparture = null;

  public selectedRole = null;

  public selectedCompany = null;

  public isSuperuser = false;

  public isServiceProvider = false;

  public createAvaliacao = false;

  public razao_social = '';

  public cnpj = '';

  public data_admissao = null;

  public termino_experiencia = null;

  public supervisor_id = 0;

  public gerente_id = 0;

  public haveGerente = false;

  public saveLoading = false;

  public allUserTools: IUserTool[] = [];

  public dominio_id: number | null = null;

  get headersTools() {
    const headers = [
      {
        text: 'Módulo',
        sortable: true,
        value: 'name',
        align: 'left',
        disabled: false,
      },
      {
        text: 'Visualizar',
        sortable: true,
        value: 'allow_view',
        align: 'center',
      },
      {
        text: 'Editar',
        sortable: true,
        value: 'allow_edit',
        align: 'center',
      },
      {
        text: 'Deletar',
        sortable: true,
        value: 'allow_delete',
        align: 'center',
      },
      {
        text: 'Adicionar',
        sortable: true,
        value: 'allow_create',
        align: 'center',
      },
    ];

    if (this.userProfile!.is_superuser) {
      headers.push({
        text: 'LOG',
        sortable: false,
        value: 'log',
        align: 'center',
      });
    }

    return headers;
  }

  get headersActions() {
    const headers = [
      {
        text: 'Ação',
        sortable: true,
        value: 'name',
        align: 'left',
        disabled: false,
      },
      {
        text: 'Módulo',
        sortable: true,
        value: 'tool_name',
        align: 'left',
        disabled: false,
      },
      {
        text: 'Descrição',
        sortable: true,
        value: 'description',
        align: 'left',
        disabled: false,
      },
      {
        text: 'Permissão',
        sortable: true,
        value: 'allow',
        align: 'left',
      },
    ];

    if (this.userProfile!.is_superuser) {
      headers.push({
        text: 'LOG',
        sortable: false,
        value: 'log',
        align: 'center',
      });
    }
    return headers;
  }

  public reg = [(v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido!'];

  @Watch('selectedCompany')
  teste() {
    //@ts-ignore
    this.allUserTools = _.filter(userToolStore.userTools, (tool) => {
      if (tool.franchising_id != 0 && (tool.franchising_id == this.user.franchising_id || !tool.franchising_id))
        return tool;
    });

    return this.allUserTools;
  }

  onChangeDataAdmissao(val: string) {
    if (val) {
      let dataExpedicao = parseISO(val);
      dataExpedicao = addDays(dataExpedicao, 44);
      this.termino_experiencia = format(dataExpedicao, "yyyy-MM-dd'T'HH:mm:ss");
    } else {
      this.termino_experiencia = null;
    }
  }

  onChangeHaveGerente() {
    this.gerente_id = 0;
  }

  get usersOptions() {
    const users = adminStore.usersFranchising;
    if (!!this.selectedCompany) {
      return users.filter((u) => u.franchising_id === this.selectedCompany.franchising_id);
    }

    return users;
  }

  get allUserOptions() {
    return adminStore.usersFranchising;
  }

  get allowEdit() {
    return this.isActive;
  }

  get userProfile() {
    return mainStore.userProfile;
  }

  get user() {
    return adminStore.user;
  }

  get userTools() {
    return this.allUserTools;
  }

  get actions() {
    return actionStore.action;
  }

  get userActions() {
    if (this.propUserId > 0) {
      return _.map(userActionStore.userActions, (ua) => {
        ua['user_id'] = this.propUserId;
        return ua;
      });
    } else {
      return _.map(userActionStore.userActions, (ua) => {
        ua.id = undefined;
        ua.allow = false;
        return ua;
      });
    }
  }

  get tools() {
    return toolStore.tools;
  }

  get companies() {
    let arr = [];
    //@ts-ignore
    arr = companyStore.companiesAutocomplete;
    if (this.userProfile?.franchising_id === 1069) {
      arr.unshift({
        //@ts-ignore
        id: 1069,
        //@ts-ignore
        nome_fantasia: 'PHENOM BRASIL IDIOMAS',
        //@ts-ignore
        franchising_id: 1069,
      });
    } else {
      //@ts-ignore
      arr.unshift({
        id: 1,
        nome_fantasia: 'KNN BRASIL LTDA',
        franchising_id: 1,
      });
      arr.unshift({
        //@ts-ignore
        id: 1069,
        //@ts-ignore
        nome_fantasia: 'PHENOM BRASIL IDIOMAS',
        //@ts-ignore
        franchising_id: 1069,
      });
    }

    return arr;
  }

  get roles() {
    let arr = roleStore.roles;
    return _.sortBy(arr, 'name');
  }

  get departures() {
    if (!this.selectedCompany) return [];
    if (this.selectedCompany!['is_franchise']) {
      return [
        {
          id: 5,
          name: 'Pedagógico',
          description: '',
        },
        {
          id: 9,
          name: 'Retenção',
          description: '',
        },
        {
          id: 2,
          name: 'Comercial',
          description: '',
        },
        {
          id: 4,
          name: 'Administrativo',
          description: '',
        },
      ];
    } else return _.sortBy(departureStore.departures, 'name');
  }

  public async submit() {
    this.saveLoading = true;
    // const success = await this.$refs.observer.validate();
    // if (!success) {
    //   this.saveLoading = false;
    //   return;
    // }
    //@ts-ignore
    if (this.id > 0) {
      const updatedUser: IUserProfileUpdate = {
        //@ts-ignore
        id: this.id,
        email: this.email,
        //@ts-ignore
        company_id: this.selectedCompany.id,
        //@ts-ignore
        role_id: this.selectedRole.id,
        //@ts-ignore
        departure_id: this.selectedDeparture.id,
        full_name: this.fullName,
        is_active: this.isActive,
        is_superuser: this.isSuperuser,
        telefone: this.telefone,
        celular: this.celular,
        tools: this.userTools,
        actions: this.userActions,
        dominio_id: this.dominio_id,
        is_service_provider: this.isServiceProvider,
      };

      //@ts-ignore
      await adminStore.updateUser({ id: this.id, user: updatedUser });
      this.saveLoading = false;
      return;
    }

    if (this.createAvaliacao) {
      if (this.data_admissao == '' || this.data_admissao === null) {
        mainStore.addNotification({
          content: 'Preencha a data de admissão para criar a avaliação',
          color: 'error',
          timeout: 2500,
        });

        this.saveLoading = false;
        return;
      }
    }

    const createdUser: IUserProfileCreate = {
      email: this.email,
      //@ts-ignore
      company_id: this.selectedCompany.id,
      //@ts-ignore
      role_id: this.selectedRole.id,
      //@ts-ignore
      departure_id: this.selectedDeparture.id,
      full_name: this.fullName,
      password: this.password1,
      is_active: this.isActive,
      telefone: this.telefone,
      celular: this.celular,
      //@ts-ignore
      is_superuser: this.isSuperuser,
      tools: this.tools,
      actions: this.userActions,
      dominio_id: this.dominio_id,
      is_service_provider: this.isServiceProvider,
    };
    //@ts-ignore
    let response = await adminStore.createUser(createdUser);

    if (response && this.createAvaliacao) {
      const createdAvaliacao: IAvaliacaoCreate = {
        nome_funcionario: this.fullName,
        numero_experiencia: 1,
        cnpj: this.cnpj,
        razao_social: this.razao_social,
        data_admissao: this.data_admissao,
        termino_experiencia: this.termino_experiencia,
        supervisor_id: this.supervisor_id,
        departure_id: this.selectedDeparture.id,
        //@ts-ignore
        cargo: this.selectedRole.name,
        colaborador_id: response,
      };

      if (this.gerente_id > 0) {
        createdAvaliacao.gerente_id = this.gerente_id;
      }

      await avaliacaoStore.createAvaliacao({ avaliacao_in: createdAvaliacao });

      window.location.reload();
    }

    this.saveLoading = false;
  }

  async triggerActive(isActive: boolean) {
    // Quando inativar um user, não permite alterar outros valores dele
    if (!isActive) {
      if (this.id) {
        this.$swal({
          icon: 'warning',
          title: 'Recarregando usuário...',
          timer: 1500,
          showConfirmButton: false,
          timerProgressBar: true,
        });
        await this.loadUser(true);
      }
    }
  }

  async loadUser(skipActive?: boolean) {
    if (this.id) {
      await adminStore.getUser(Number(this.id));
      await userToolStore.getToolsByUserId(this.user!.id!);
      await userActionStore.getUserActions(this.user!.id!);

      for (let i = 0; i < this.userTools.length; i++) {
        const tool = this.userTools[i];
        this.userTools.forEach((item) => {
          item.allow_create = tool.allow_create;
          item.allow_delete = tool.allow_delete;
          item.allow_edit = tool.allow_edit;
          item.allow_view = tool.allow_view;
        });
      }

      this.email = this.user.email;
      this.fullName = this.user.full_name;

      if (!skipActive) {
        this.isActive = this.user.is_active;
      }

      this.celular = this.user.celular;
      this.telefone = this.user.telefone;

      this.dominio_id = this.user.dominio_id;

      //@ts-ignore
      this.selectedCompany = this.user.company;
      this.isSuperuser = this.user.is_superuser;

      //@ts-ignore
      this.selectedRole = this.roles.find((item) => {
        return item.id === this.user.role_id;
      });
      //@ts-ignore
      this.selectedDeparture = this.departures.find((item) => {
        return item.id === this.user.departure_id;
      });

      this.isServiceProvider = this.user.is_service_provider;
    }
  }

  public async mounted() {
    await roleStore.getRoles();
    await departureStore.getDepartures();
    await companyStore.getCompaniesAutoComplete({ is_franchise: true });
    if (this.propUserId > 0) {
      this.id = this.propUserId;
      await this.loadUser();
    } else {
      await toolStore.getTools();
      this.tools.forEach((item) => {
        item.allow_view = false;
        item.allow_edit = false;
        item.allow_delete = false;
        item.allow_create = false;
        item['tool_id'] = item.id;
      });
    }
  }
}
